import { responsiveMediaFragment } from '~/gql/mediaFragments.gql'
import {
  localeFragment,
} from './fragments.gql'

export default `query 
  PromotionTileTurnaroundQuery($locale: SiteLocale) {
    promotionTileTurnaround(${localeFragment}) {
      ${responsiveMediaFragment('image')}
      ${responsiveMediaFragment('imageDonut')}
      title
      copy
      button
      formDiscount
      promotions {
        promotionRuleIds
        promotionId
        copy
        callback
      }
    }
  }`
